module.exports = __webpack_public_path__ + "img/FacilityMap2x.364d0d14.png";